import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { scrollToTop } from "@/lib/utilsUI";
import bckWoop from "@/assets/Logo-AppWhoop.webp";

export default function ExperienciaCard({ ticket: experiencia }) {
  if (!experiencia) return null;

  return (
    <div className="min-w-[200px] max-w-[200px] bg-aw-bluedark rounded-b-xl shadow-lg overflow-hidden flex flex-col">
      {/* Imagen */}
      <Link
        to={`/experiencias/${experiencia.slug}`}
        onClick={scrollToTop}
        className="h-52 block overflow-hidden relative border-2 border-aw-green bg-aw-bluegray flex-shrink-0"
      >
        <img
          src={bckWoop}
          alt="Placeholder"
          className="absolute inset-0 w-2/3 h-2/3 m-auto object-cover z-0 opacity-30"
        />
        <LazyLoadImage
          src={experiencia.imagenPrincipal}
          placeholderSrc={bckWoop}
          alt={experiencia.titulo}
          height="100%"
          width="100%"
          effect="blur"
          className="w-full h-full object-cover z-10"
          loading="lazy"
        />
        {/* Badge categoría */}
        {experiencia.categoria && (
          <span className="absolute top-2 left-2 bg-aw-green text-aw-bluedark text-xs font-semibold px-2 py-0.5 rounded-full z-20">
            {experiencia.categoria}
          </span>
        )}
      </Link>

      {/* Info */}
      <div className="px-2 py-2 flex flex-col gap-1 flex-1">
        <h3 className="font-bold text-sm text-white line-clamp-2 leading-tight">
          {experiencia.titulo}
        </h3>
        <p className="text-xs text-gray-400 line-clamp-2 leading-snug">
          {experiencia.resumen}
        </p>
      </div>

      {/* CTA */}
      <Link
        to={`/experiencias/${experiencia.slug}`}
        onClick={scrollToTop}
        className="w-full h-9 flex items-center justify-center bg-aw-green text-black font-semibold text-sm py-1 hover:scale-110 transition duration-300"
      >
        Ver más
      </Link>
    </div>
  );
}
